<template>
  <div>
    <div class="navbar" v-bind:class="{ navbarbg: changeBg }" :style="shadow">
      <div class="navbar-left">
        <router-link to="/" @click.native="flushCom">
<!--          <img src="@/assets/logo.png">-->
          <img :src="pageIndex!=1&&pageIndex!=6&&scrollTop<50?logo_light:logo">
        </router-link>
      </div>
      <div class="navbar-right">
        <router-link to="/" @click.native="flushCom">
          <div class="navbar-item" :style="{ 'color':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'#fff':'#000') }"> 蓝猿之家</div>
            <div class="navbar-item-active" v-if="pageIndex==1"
               :style="{ 'border':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'1px solid #fff':'1px solid #000') }"></div>
        </router-link>
        <router-link to="/product" @click.native="flushCom">
          <div class="navbar-item" :style="{ 'color':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'#fff':'#000') }"> 我的手艺</div>
          <div class="navbar-item-active" v-if="pageIndex==2||pageIndex==6"
               :style="{ 'border':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'1px solid #fff':'1px solid #000') }"></div>
        </router-link>
        <router-link to="/service" @click.native="flushCom">
          <div class="navbar-item" :style="{ 'color':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'#fff':'#000') }"> 擅长技能</div>
          <div class="navbar-item-active" v-if="pageIndex==3"
               :style="{ 'border':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'1px solid #fff':'1px solid #000') }"></div>
        </router-link>
        <router-link to="/about" @click.native="flushCom">
          <div class="navbar-item" :style="{ 'color':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'#fff':'#000') }"> 想对你说</div>
          <div class="navbar-item-active" v-if="pageIndex==4"
               :style="{ 'border':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'1px solid #fff':'1px solid #000') }"></div>
        </router-link>
        <router-link to="/contact" @click.native="flushCom">
          <div class="navbar-item" :style="{ 'color':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'#fff':'#000') }"> 联系我们</div>
          <div class="navbar-item-active" v-if="pageIndex==5"
               :style="{ 'border':(pageIndex!=1&&pageIndex!=6&&scrollTop<50?'1px solid #fff':'1px solid #000') }"></div>
        </router-link>
      </div>
      <div class="nav-sm" @click="onShowNav()">
        <div class="icon"></div>
        <div class="icon"></div>
        <div class="icon"></div>
      </div>
      <div class="mask" :style="{'right':(showNav?'0px':'-100%')}" @click="hideNav()">
        <div class="nav-sm-box">
          <router-link to="/" @click.native="flushCom">
            <div class="nav-sm-item">蓝猿之家</div>
          </router-link>
          <router-link to="/product" @click.native="flushCom">
            <div class="nav-sm-item">我的手艺</div>
          </router-link>
          <router-link to="/service" @click.native="flushCom">
            <div class="nav-sm-item">擅长技能</div>
          </router-link>
          <router-link to="/about" @click.native="flushCom">
            <div class="nav-sm-item">想对你说</div>
          </router-link>
          <router-link to="/contact" @click.native="flushCom">
            <div class="nav-sm-item">联系我们</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "navbar",
    data() {
      return {
        changeBg: false,
        shadow: {
          boxShadow: "none",
        },
        showNav: false,
        logo:require("@/assets/image/logo.png"),
        logo_light:require("@/assets/image/logo-light.png"),
        scrollTop:0
      }
    },
    props: ['pageIndex', 'currentScreen'],
    mounted() {
          this.changeBg = true
          window.addEventListener('scroll', this.handleScroll, true);
        // }
      // }
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        this.scrollTop=scrollTop
        if (scrollTop >= 50) {
          this.changeBg = false
        } else {
          this.changeBg = true
        }
        if ((this.pageIndex==1&&scrollTop >= 900)||(this.pageIndex!=1&&scrollTop>250)) {
          this.shadow.boxShadow = "0 0 10px #eee"
        } else {
          this.shadow.boxShadow = "none"
        }
      },
      flushCom() {
        this.$router.go(0)
      },
      onShowNav() {
        this.showNav = !this.showNav
      },
      hideNav() {
        this.showNav = false
      }
    }
  }
</script>

<style scoped>
  .navbar {
    width: 100%;
    height: 75px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    box-sizing: border-box;
    align-items: center;
    background-color: #fff;
    /*border-bottom: 1px solid #f7f7f7;*/
    transition: all .5s;
  }

  .navbarbg {
    background-color: transparent;
    border-bottom: 1px solid #f7f7f7;
    border: none;
  }

  .navbar-right {
    display: flex;
    align-items: center;
    min-width: 520px;
    /*font-weight: bold;*/
    /*margin-left: 45%;*/
    margin-right: 200px;
  }

  .navbar-item {
    height: 75px;
    margin: auto;
    padding: 0 20px;
    line-height: 75px;
    box-sizing: border-box;
    /*border-bottom: 2px solid #5fbbb6;*/
  }

  .navbar-item-active {
    width: 30px;
    border: 1px solid #333;
    margin: 0 auto;
    position: relative;
    top: -10px
  }

  .navbar-item:hover {
    transform: scale(1.05);
    font-weight: bold;
  }

  .navbar-left {
    display: flex;
    align-items: center;
    margin-left: 60px;
    /*margin-right: 30%;*/
  }

  .navbar-left img {
    height: 50px;
  }

  .nav-sm {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px 0 7px;
    box-sizing: border-box;
    display: none;
    transition: transform .2s;
    z-index: 999;
  }

  .nav-sm:hover {
    transform: rotate(90deg);
  }

  .icon {
    /*height: 6px;*/
    width: 32px;
    border-top: 2.5px solid #333;
    border-bottom: 2.5px solid #333;
    border-radius: 20px;
    margin: 5px auto;
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    transition: right .8s;
    z-index: 9;
  }

  .nav-sm-box {
    width: 200px;
    height: 100vh;
    /*border-left: 1px solid #eee;*/
    /*border-top: 1px solid #eee;*/
    box-shadow: 0 0 10px #e3e3ed;
    background-color: #fff;
    position: absolute;
    top: 60px;
    right: 0;
    line-height: 80px;
    text-indent: 2em;
    z-index: 10;
    /*padding-top: 20px;*/
  }

  .nav-sm-item {
    height: 80px;
  }

  @media (max-width: 992px) {
    .navbar {
      height: 60px;
      flex-direction: row;
      /*background-color: #fff;*/
    }

    .navbar-right {
      display: none;
      margin: 0;
    }

    .nav-sm {
      display: block;
    }

    .navbar-left {
      margin-left: 0;
    }

    .navbar-left img {
      height: 42px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue